import { breakpoint, theme } from "@utilities";
import { Z_INDEX } from "@constants";
import styled from "styled-components";

export const StyledNavigator = styled.div`
    position: sticky;
    display: flex;
    align-items: center;
    padding: 25px 18px 25px 18px;
    justify-content: space-between;
    background-color: #fff;
    width: 100%;
    z-index: ${Z_INDEX.NAV_HIGH};
    top: 0;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);

    .backBtn {
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        /* An image carries its intrinsic width as a minimum, so without this the
           logo refuses to shrink and pushes the icons past the right edge instead
           of giving up its own space. */
        min-width: 0;
        overflow: hidden;

        span {
            font-weight: 700;
            font-size: 16px;
            margin-left: 5px;
        }
    }

    .menu {
        display: flex;
        justify-content: center;
        align-items: center;
        /* Search, cart and account keep their width whatever the logo wants. */
        flex-shrink: 0;

        .iconWrapper {
            margin-left: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            svg {
                path {
                    stroke: #37445d;
                }
            }

            /* Anchors the alert badge below; these icons are otherwise bare. */
            position: relative;

            /* Flags an account still carrying the password generated at sign-up.
               Matches the badge on the desktop header's account icon. */
            .passwordAlert {
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 15px;
                height: 15px;
                top: -4px;
                right: -6px;
                border-radius: 50%;
                background-color: ${theme.colors.red};
                border: 1.5px solid #fff;
                color: #fff;
                font-size: 10px;
                font-weight: 700;
                line-height: 1;
                pointer-events: none;
            }
        }
    }

    .cartIconWrapper {
        position: relative;
        width: 26px;
        height: 26px;

        .number {
            position: absolute;
            display: inline-block;
            width: 14px;
            height: 14px;
            font-size: 10px;
            line-height: 14px;
            border-radius: 50%;
            text-align: center;
            color: ${theme.colors.button_text};
            top: 0;
            left: 100%;
            transform: translateX(-50%);
            background-color: ${theme.colors.main};
            z-index: ${Z_INDEX.CONTENT_MID};
        }
    }

    ${breakpoint.breakTablet`
        display: none;
    `}

    .logo {
        height: 28px;
        position: relative;

        .logoItem {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            width: 200px;

            ${breakpoint.breakIpadPro`
                width:300px;
            `}

            ${breakpoint.breakTablet`
                width:300px;
            `}

            ${breakpoint.breakLarge`
                width:350px;
            `}
        }
    }
`;
